import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { addFranchiseStoreMap, addFranchiseUser, getFranchiseAvailableUser, updateFranchiseStoreMap, updateFranchiseUser } from "../../../services/FranchiseModal/Franchise";
import { Dropdown } from "primereact/dropdown";
import { getBrandUsers } from "../../../services/StoreUsers/PostStoreUsers";

const FranchiseUserMap = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item, franchise } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [userData, setUserData] = useState("");
  const [userStatus, setUserStatus] = useState(false);
  const [statusError, setStatusError] = useState("");
  const [storeUserData, setStoreUserData] = useState([]);

 const fetchStoreUser = () => {
     getFranchiseAvailableUser(brandId)
       .then((response) => {
         if (!response.data.error) {
           const users = response.data;
           const usersRes = users.map((item, index) => ({
             name: item.firstName + " " + item.lastName,
             value: item.id,
           }));
           
           setStoreUserData(usersRes);
         }
       })
       .catch((err) => {
         console.error("Error:", err);
       });
   };
  useEffect(() => {
    if (item) {
      setUserData(item.user.id);
      setUserStatus(item.status);
    }
  }, [item]);

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const [userError, setUserError] = useState("");

  const handleUserChange = (selectedItem) => {
    setUserData(selectedItem);
  };

  const userName = item?.user?.firstName + " " + item?.user?.lastName;

  const StatusList = [
    {
      name: "ACTIVE",
      value: true,
    },
    {
      name: "INACTIVE",
      value: false,
    },
  ];

  const handleStatusChange = (selectedItem) => {
    setUserStatus(selectedItem);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setUserError("");
    setStatusError("");

    let isValid = true;
    if (item === null && !userData) {
      setUserError("User is Required");
      isValid = false;
    }
    if (userStatus === null) {
      setStatusError("Status is Required");
      isValid = false;
    }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          user: {
            id: userData,
          },
        };

        const UpdateData = {
          id: item?.id,
          brandFranchise: {
            id: franchise.id,
          },
          user: {
            id: userData,
          },
          status: userStatus,
        };

        // Call the service function for creating pickup request

        if (item === null) {
          addFranchiseUser(brandId, franchise.id, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/franchise-user-mapped-list", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateFranchiseUser(brandId, franchise.id, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/franchise-user-mapped-list", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/franchise-user-mapped-list", {
                      state: {
                        item: franchise,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise User {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className=" mt-2 mx-4 flex-1">
          <p className="text-xl text-black font-bold capitalize">
            Previously Selected User : {userName}
          </p>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className=" mt-4 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="user"
              value={userData}
              onChange={(e) => handleUserChange(e.target.value)}
              options={storeUserData}
              optionLabel="name"
              placeholder="User"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {userError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {userError}
              </p>
            )}
            <label htmlFor="user" className="text-md" style={{ color: "blue" }}>
              User <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      {item !== null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="status"
                value={userStatus}
                onChange={(e) => handleStatusChange(e.target.value)}
                options={StatusList}
                optionLabel="name"
                placeholder="status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="status"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default FranchiseUserMap;
